import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { MODAL_SIZES } from "@circle-react-uikit/ModalV2/ModalContent";
import { FormContent } from "../FormContent";
import type { FormRenderingContextValue } from "../contexts/FormRenderingContext";
import {
  FormRenderingProvider,
  useFormRenderingContext,
} from "../contexts/FormRenderingContext";
import { useModalCookie } from "../hooks/useModalCookie";
import { ModalHeader } from "./ModalHeader";

export const FormModalComponent = () => {
  const modal = useModal();

  const { form, index, initialFocusRef, formBackgroundColor, formTextColor } =
    useFormRenderingContext();
  const { suppressPopupForm } = useModalCookie();
  if (!modal || !modal.visible) return null;

  const handleClose = () => {
    suppressPopupForm();
    void modal.hide();
    // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
    window.parent.postMessage(
      { type: "resize", formUid: form.uid, formIndex: index, height: "0" },
      "*",
    );
  };
  return (
    <Modal
      isOpen={modal.visible}
      contentPortalId="form-modal-portal"
      initialFocus={initialFocusRef}
    >
      <Modal.Overlay onClick={handleClose} />
      <Modal.Content
        size={MODAL_SIZES.md}
        style={{ backgroundColor: formBackgroundColor }}
        id={`form-modal-${form.uid}`}
      >
        <style>
          {`#form-modal-${form.uid} #form-modal-close-button:hover {
             background-color: ${formBackgroundColor};
           }
           #form-modal-${form.uid} h4,
           #form-modal-${form.uid} #form-modal-close-button svg {
             color: ${formTextColor} !important;
           }`}
        </style>
        <ModalHeader handleClose={handleClose} />
        <Modal.Body className="px-8 !pt-0">
          <FormContent />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

interface FormModalProps {
  formRenderingContextValue: FormRenderingContextValue;
}
const FormModal = ModalManager.create(
  ({ formRenderingContextValue }: FormModalProps) => (
    <FormRenderingProvider {...formRenderingContextValue}>
      <FormModalComponent />
    </FormRenderingProvider>
  ),
);
export const useFormModal = () => useModal(FormModal);
